<template>
  <div>
    <b-notification :has-icon="true" icon="database" :closable="false">
      <span v-html="$t('compCarbonFormsPurchasesHelpData.text')" />
    </b-notification>
    <help-file-extraction />
    <br />
    <help-file-format />
  </div>
</template>

<script>
export default {
  name: 'HelpData',
  components: {
    'help-file-extraction': () =>
      import('@/components/carbon/forms/purchases/HelpFileExtraction.vue'),
    'help-file-format': () =>
      import('@/components/carbon/forms/purchases/HelpFileFormat.vue')
  }
}
</script>
